module.exports = __webpack_public_path__ + "static/media/communities.81779ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Communities/assets/communities.jpg
// module id = 386
// module chunks = 0